/* KL — membership plan buttons (Bold Memberships V2 / MemTwo).
   Moved out of snippets/membership-plan-buttons-v2.liquid on 2026-09-17 so the
   join page can use the same code. WHY: Bold's storefront scripts (extension
   recurring-memberships-109, 14 Sep 2026) stopped handling the page content's
   <a href="#" class="bm-join-btn"> links, so the five JOIN buttons on
   /pages/become-a-knowing-look-member jumped to the top of the page. Both
   surfaces now go through Bold's supported entry points — see the snippet's
   header comment for the mechanism, the no-clear trade-off and the
   registration-fields fallback (all unchanged here).
   Wires: .kl-plan-btn[data-kl-plan-tag]  (data-kl-expected-price optional). */
(function () {
  'use strict';

  // Every tagged plan button on the page: the manage-membership cards
  // (snippets/membership-plan-buttons-v2.liquid) and the five join links on
  // /pages/become-a-knowing-look-member (templates/page.membership.liquid
  // tags the page content's .bm-join-btn anchors before this runs).
  var buttons = document.querySelectorAll('.kl-plan-btn[data-kl-plan-tag]');
  if (!buttons.length) { return; }
  var GENERIC = 'Memberships are temporarily unavailable. Please refresh, or email support@knowinglookapparel.com.';

  function errorEl(b) {
    var c = b.parentElement; if (!c) { return null; }
    var e = c.querySelector('[data-kl-error]');
    if (!e) { e = document.createElement('div'); e.className = 'kl-plan-error'; e.setAttribute('data-kl-error', ''); e.setAttribute('role', 'alert'); c.appendChild(e); }
    return e;
  }
  function showError(b, m) { var e = errorEl(b); if (e) { e.textContent = m; e.classList.add('is-visible'); } }
  function clearError(b) { var e = errorEl(b); if (e) { e.textContent = ''; e.classList.remove('is-visible'); } }
  function disable(b, m) { b.disabled = true; b.classList.add('is-disabled'); b.setAttribute('aria-disabled', 'true'); showError(b, m); }

  // Bold's app embed loads bm-core + bm-checkout-api asynchronously.
  var waited = 0;
  (function waitForBold() {
    var api = window.BoldMemberships;
    var ready = api &&
                typeof api.addMembershipToCart === 'function' &&
                typeof api.startCheckout === 'function' &&
                window.BoldMembershipsConfig &&
                Array.isArray(window.BoldMembershipsConfig.signupPlans);

    if (!ready) {
      waited += 150;
      if (waited > 9000) {
        Array.prototype.forEach.call(buttons, function (b) { disable(b, GENERIC); });
        console.error('[KL] Bold Memberships checkout API unavailable after 9s.');
        return;
      }
      return void setTimeout(waitForBold, 150);
    }
    wire(window.BoldMembershipsConfig.signupPlans);
  })();

  function wire(plans) {
    Array.prototype.forEach.call(buttons, function (btn) {
      var tag = btn.getAttribute('data-kl-plan-tag');

      var plan = null;
      for (var i = 0; i < plans.length; i++) {
        if (plans[i].plan_tag === tag) { plan = plans[i]; break; }
      }
      if (!plan) {
        disable(btn, 'This membership is not currently available.');
        console.error('[KL] No MemTwo plan matches plan_tag "' + tag + '".');
        return;
      }

      var opt = null;
      var opts = plan.billing_options || [];
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].is_active !== false) { opt = opts[j]; break; }
      }
      if (!opt) {
        disable(btn, 'This membership is not currently available.');
        console.error('[KL] Plan "' + tag + '" has no active billing option.');
        return;
      }

      // Drift guard — warn only, never blocks signup.
      var expected = parseFloat(btn.getAttribute('data-kl-expected-price'));
      if (!isNaN(expected) && Number(opt.price) !== expected) {
        console.warn('[KL] Price drift on "' + tag + '": copy says $' + expected +
                     ', MemTwo charges $' + opt.price + '. Update the snippet copy.');
      }

      // Rebuild the price line under the button from Bold's actual figures, so
      // it can never drift from what the customer is charged. The markup holds
      // a correct server-rendered default in case this never runs.
      //   yearly  -> "PRIMO ($3.50/month, $42.00/year)"
      //   monthly -> "EPIC MONTHLY ($5.00/month)"
      var descEl = btn.parentElement && btn.parentElement.querySelector('[data-kl-desc]');
      if (descEl) {
        var label = descEl.getAttribute('data-kl-desc') || '';
        var price = Number(opt.price);
        if (!isNaN(price) && price > 0) {
          var isYearly = String(opt.billing_cycle).toLowerCase() === 'yearly';
          var perMonth = isYearly ? price / 12 : price;
          var line = label + ' ($' + perMonth.toFixed(2) + '/month';
          if (isYearly) { line += ', $' + price.toFixed(2) + '/year'; }
          line += ')';
          descEl.textContent = line;
        }
      }

      var needsRegistration = !!(plan.registration_fields && plan.registration_fields.length > 0);

      btn.addEventListener('click', function (ev) {
        if (ev && ev.preventDefault) { ev.preventDefault(); } // the join page's buttons are <a href="#">: never let the browser jump to the top
        if (btn.disabled || btn.classList.contains('is-disabled') || btn.classList.contains('is-busy')) { return; }

        clearError(btn);
        var originalText = btn.textContent;
        btn.classList.add('is-busy');
        btn.textContent = 'Updating cart…';

        var args = { planId: plan.id, billingOptionId: opt.id };

        function fail(err) {
          console.error('[KL] Membership checkout failed:', err);
          showError(btn, (err && err.message) ||
            'Something went wrong. Please try again, or email support@knowinglookapparel.com.');
          btn.classList.remove('is-busy');
          btn.textContent = originalText;
        }

        // Plans with registration fields need Bold's modal, which only
        // startCheckout provides. That path clears the cart — Bold's design.
        if (needsRegistration) {
          console.warn('[KL] Plan "' + tag + '" has registration fields; using startCheckout (clears cart).');
          window.BoldMemberships.startCheckout(args).catch(fail);
          return;
        }

        // REPLACE-NOT-ADD (added 2026-07-30 after live test).
        // Bold's cart clear was preventing two things, not one: mixed carts
        // AND multiple memberships. We deliberately kept mixed carts, so we
        // must handle the second ourselves — a shopper who clicks two JOIN
        // buttons would otherwise be billed for both.
        // removeMembershipFromCart({}) with no variantId reads
        // bridge.getMembershipProducts().variantIds and removes ONLY
        // membership line items, by line key. Shirts are untouched.
        // If it fails we continue rather than block signup: worst case is the
        // old stacking behaviour, which beats a dead JOIN button.
        var api = window.BoldMemberships;
        var prep = (typeof api.removeMembershipFromCart === 'function')
          ? api.removeMembershipFromCart({}).catch(function (e) {
              console.warn('[KL] removeMembershipFromCart failed; continuing (membership may stack):', e);
            })
          : Promise.resolve();

        prep
          .then(function () {
            btn.textContent = 'Adding to cart…';
            return api.addMembershipToCart(args);
          })
          .then(function () {
            btn.textContent = 'Redirecting to checkout…';
            window.location.href = '/checkout';
          })
          .catch(fail);
      });
    });
  }
})();
